/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var UiMenuDots8VIcon16Solid = forwardRef('UiMenuDots8VIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M6 3.498A1.499 1.499 0 1 0 6 .5a1.499 1.499 0 0 0 0 2.998Z" }),
        React.createElement("path", { d: "M10 3.498A1.499 1.499 0 1 0 10 .5a1.499 1.499 0 0 0 0 2.998Z" }),
        React.createElement("path", { d: "M7.499 6A1.499 1.499 0 1 1 4.5 6a1.499 1.499 0 0 1 2.998 0Z" }),
        React.createElement("path", { d: "M10 7.499a1.499 1.499 0 1 0 0-2.998A1.499 1.499 0 0 0 10 7.5Z" }),
        React.createElement("path", { d: "M7.499 10A1.499 1.499 0 1 1 4.5 10a1.499 1.499 0 0 1 2.998 0Z" }),
        React.createElement("path", { d: "M10 11.499a1.499 1.499 0 1 0 0-2.998 1.499 1.499 0 0 0 0 2.998Z" }),
        React.createElement("path", { d: "M7.499 13.999a1.499 1.499 0 1 1-2.998 0 1.499 1.499 0 0 1 2.998 0Z" }),
        React.createElement("path", { d: "M10 15.498a1.499 1.499 0 1 0 0-2.998 1.499 1.499 0 0 0 0 2.998Z" })));
});
